import { isPartialMatch } from '../../../utils/helpers';
import { RESET_USER } from '../../auth/store/types';
import {
  GET_ACTIVE_USERS,
  GET_ACTIVE_USERS_LOADING,
  GET_ACTIVE_USERS_ERROR,
  GET_CORPORATE_LIST_LOADING,
  GET_CORPORATE_LIST,
  GET_CORPORATE_LIST_ERROR,
  DOWNLOAD_PDF_LOADING,
  DOWNLOAD_PDF,
  DOWNLOAD_PDF_ERROR,
  GET_PAID_REGISTERED_USERS_LOADING,
  GET_PAID_REGISTERED_USERS,
  GET_PAID_REGISTERED_USERS_ERROR,
  GET_KPI_DATA_LOADING,
  GET_KPI_DATA,
  GET_KPI_DATA_ERROR,
  GET_TOTAL_USERS_PLAYED_CONTENT_LOADING,
  GET_TOTAL_USERS_PLAYED_CONTENT,
  GET_TOTAL_USERS_PLAYED_CONTENT_ERROR,
  GET_USERS_RATED_THE_CONTENT_LOADING,
  GET_USERS_RATED_THE_CONTENT,
  GET_USERS_RATED_THE_CONTENT_ERROR,
  GET_USERS_FAVORITE_THE_CONTENT_LOADING,
  GET_USERS_FAVORITE_THE_CONTENT,
  GET_USERS_FAVORITE_THE_CONTENT_ERROR,
  GET_NUMBER_OF_PC_COMPLETED_LOADING,
  GET_NUMBER_OF_PC_COMPLETED,
  GET_NUMBER_OF_PC_COMPLETED_ERROR,
  GET_NUMBER_OF_PC_BOOKINGS_LOADING,
  GET_NUMBER_OF_PC_BOOKINGS,
  GET_NUMBER_OF_PC_BOOKINGS_ERROR,
  GET_NUMBER_OF_USERS_TAKE_WATER_LOADING,
  GET_NUMBER_OF_USERS_TAKE_WATER,
  GET_NUMBER_OF_USERS_TAKE_WATER_ERROR,
  GET_TOTAL_WATER_INTAKE_LOADING,
  GET_TOTAL_WATER_INTAKE,
  GET_TOTAL_WATER_INTAKE_ERROR,
  GET_TOTAL_EARNED_REWARD_POINTS_LOADING,
  GET_TOTAL_EARNED_REWARD_POINTS,
  GET_TOTAL_EARNED_REWARD_POINTS_ERROR,
  GET_TOTAL_USERS_EARNED_REWARDS_LOADING,
  GET_TOTAL_USERS_EARNED_REWARDS,
  GET_TOTAL_USERS_EARNED_REWARDS_ERROR,
  GET_TOTAL_USERS_REDEEMED_REWARDS_LOADING,
  GET_TOTAL_USERS_REDEEMED_REWARDS,
  GET_TOTAL_USERS_REDEEMED_REWARDS_ERROR,
  GET_TOTAL_PUSH_SENT_LOADING,
  GET_TOTAL_PUSH_SENT,
  GET_TOTAL_PUSH_SENT_ERROR,
  GET_TOTAL_CHALLENGES_LAUNCHED_LOADING,
  GET_TOTAL_CHALLENGES_LAUNCHED,
  GET_TOTAL_CHALLENGES_LAUNCHED_ERROR,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LOADING,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_ERROR,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LOADING,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_ERROR,
  GET_PROGRAM_JOINED_LOADING,
  GET_PROGRAM_JOINED,
  GET_PROGRAM_JOINED_ERROR,
  GET_PROGRAM_COMPLETED_LOADING,
  GET_PROGRAM_COMPLETED,
  GET_PROGRAM_COMPLETED_ERROR,
  GET_BOOK_READ_LOADING,
  GET_BOOK_READ,
  GET_BOOK_READ_ERROR,
  GET_TOTAL_MINS_PLAYED_LOADING,
  GET_TOTAL_MINS_PLAYED,
  GET_TOTAL_MINS_PLAYED_ERROR,
  GET_TOTAL_STEPS_CAPTURED_LOADING,
  GET_TOTAL_STEPS_CAPTURED,
  GET_TOTAL_STEPS_CAPTURED_ERROR,
  GET_TOTAL_USER_SYNCING_STEPS_LOADING,
  GET_TOTAL_USER_SYNCING_STEPS,
  GET_TOTAL_USER_SYNCING_STEPS_ERROR,
  SAVE_CURRENT_DATE_RANGE,
  DOWNLOAD_OVERALL_REPORT,
  DOWNLOAD_OVERALL_REPORT_LOADING,
  DOWNLOAD_OVERALL_REPORT_ERROR,
  GET_INDIVIDUAL_DETAILS_LOADING,
  GET_INDIVIDUAL_DETAILS,
  GET_INDIVIDUAL_DETAILS_ERROR,
  SAVE_SELECTED_COMPANY,
  SAVE_CURRENT_DATE_RANGE_FOR_INDIVIDUAL,
  GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS,
  GET_TOTAL_MINS_PLAYED_LAST_90_DAYS,
  GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS,
  GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS,
  GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS,
  GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS,
  GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS,
  GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS,
  GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS,
  GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS,
  GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS,
  GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS,
  GET_TOTAL_PUSH_SENT_LAST_90_DAYS,
  GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS,
  GET_PROGRAM_JOINED_LAST_90_DAYS,
  GET_PROGRAM_COMPLETED_LAST_90_DAYS,
  GET_BOOK_READ_LAST_90_DAYS,
  GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS,
  GET_TOTAL_MINS_PLAYED_LAST_30_DAYS,
  GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS,
  GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS,
  GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS,
  GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS,
  GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS,
  GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS,
  GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS,
  GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS,
  GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS,
  GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS,
  GET_TOTAL_PUSH_SENT_LAST_30_DAYS,
  GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS,
  GET_PROGRAM_JOINED_LAST_30_DAYS,
  GET_PROGRAM_COMPLETED_LAST_30_DAYS,
  GET_BOOK_READ_LAST_30_DAYS,
  GET_ACTIVE_USERS_LAST_90_DAYS,
  GET_ACTIVE_USERS_LAST_30_DAYS,
  GET_PAID_REGISTERED_USERS_LAST_90_DAYS,
  GET_PAID_REGISTERED_USERS_LAST_30_DAYS,
  SAVE_DATE_RANGE_12_MONTHS,
  SAVE_DATE_RANGE_90_DAYS,
  SAVE_DATE_RANGE_30_DAYS,
  SAVE_DATE_RANGE_FOR_90_DAYS_INDIVIDUAL,
  SAVE_DATE_RANGE_FOR_30_DAYS_INDIVIDUAL,
  GET_INDIVIDUAL_DETAILS_LAST_90_DAYS,
  GET_INDIVIDUAL_DETAILS_LAST_30_DAYS,
  GET_AUDIO_BOOKS_ALLOCATION,
  GET_CAMPAIGN_AND_CHANNEL,
  GET_TOTAL_REDEEMED_REWARD_POINTS_LOADING,
  GET_TOTAL_REDEEMED_REWARD_POINTS,
  GET_TOTAL_REDEEMED_REWARD_POINTS_ERROR,
  GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS,
  GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS,
  GET_CAMPAIGN_DETAILS,
  GET_AUDIOBOOKS_DETAILS,
  SAVE_CORP_ID_NAME_MAP,
  GET_FREEMIUM_CORPORATE_LIST_LOADING,
  GET_FREEMIUM_CORPORATE_LIST,
  GET_FREEMIUM_CORPORATE_LIST_ERROR,
  SAVE_FREEMIUM_CORP_ID_NAME_MAP,
  SAVE_KPI_DATA_DUMP,
  DOWNLOAD_KPI_DATA_DUMP,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_SUCCESS,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LOADING,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_ERROR,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS,
  FETCH_TOTAL_MEALS_ADDED_SUCCESS,
  FETCH_TOTAL_MEALS_ADDED_LOADING,
  FETCH_TOTAL_MEALS_ADDED_ERROR,
  FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS,
  FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS,
  FETCH_TOTAL_AI_COACH_MESSAGES_SUCCESS,
  FETCH_TOTAL_AI_COACH_MESSAGES_LOADING,
  FETCH_TOTAL_AI_COACH_MESSAGES_ERROR,
  FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS,
  FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS,
  FETCH_UNIQUE_NUTRITION_USERS_SUCCESS,
  FETCH_UNIQUE_NUTRITION_USERS_LOADING,
  FETCH_UNIQUE_NUTRITION_USERS_ERROR,
  FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS,
  FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS,
} from './types';

const initialState = {
  currentDateRange: {
    startDate: null,
    endDate: null,
    oldStartDate: null,
    oldEndDate: null,
    quarterly: false,
  },
  selectedCompany: null,
  corporateList: {
    loading: false,
    error: null,
    data: [],
  },
  freemiumCorporateList: {
    loading: false,
    error: null,
    data: [],
  },
  cropIdNameMap: {},
  freemiumCropIdNameMap: {},
  last12Months: {
    dateRange: {
      startDate: null,
      endDate: null,
      oldStartDate: null,
      oldEndDate: null,
    },
    paidRegisteredUsers: {
      loading: false,
      error: null,
      data: null,
    },
    activeUsers: {
      loading: false,
      error: null,
      data: null,
    },
    kpiData: {
      loading: false,
      error: null,
      data: null,
    },
    totalUsersPlayedContent: {
      loading: false,
      error: null,
      data: null,
    },
    usersRatedTheContent: {
      loading: false,
      error: null,
      data: null,
    },
    usersFavoriteTheContent: {
      loading: false,
      error: null,
      data: null,
    },
    numberOfPcCompleted: {
      loading: false,
      error: null,
      data: null,
    },
    numberOfPcBookings: {
      loading: false,
      error: null,
      data: null,
    },
    numberOfUsersTakingWaterIntake: {
      loading: false,
      error: null,
      data: null,
    },
    totalWaterIntake: {
      loading: false,
      error: null,
      data: null,
    },
    totalEarnedRewardPoints: {
      loading: false,
      error: null,
      data: null,
    },
    totalRedeemedRewardPoints: {
      loading: false,
      error: null,
      data: null,
    },
    totalUsersEarnedReward: {
      loading: false,
      error: null,
      data: null,
    },
    totalUsersRedeemedReward: {
      loading: false,
      error: null,
      data: null,
    },
    totalPushSent: {
      loading: false,
      error: null,
      data: null,
    },
    totalChallengesLaunched: {
      loading: false,
      error: null,
      data: null,
    },
    totalUsersJoinedInChallenge: {
      loading: false,
      error: null,
      data: null,
    },
    totalUsersParticipatedInChallenge: {
      loading: false,
      error: null,
      data: null,
    },
    programJoined: {
      loading: false,
      error: null,
      data: null,
    },
    programCompleted: {
      loading: false,
      error: null,
      data: null,
    },
    bookRead: {
      loading: false,
      error: null,
      data: null,
    },
    totalMinsPlayed: {
      loading: false,
      error: null,
      data: null,
    },
    totalStepsCaptured: {
      loading: false,
      error: null,
      data: null,
    },
    totalUsersSyncingSteps: {
      loading: false,
      error: null,
      data: null,
    },
  },
  last90Days: {},
  last30Days: {},
  individualDetails: {
    loading: false,
    error: null,
    currentDateRange: {},
    data: {},
  },
  individualDetailsLast90Days: {
    loading: false,
    error: null,
    dateRange: {},
    data: {},
  },
  individualDetailsLast30Days: {
    loading: false,
    error: null,
    dateRange: {},
    data: {},
  },
  audiobooksAllocation: {
    loading: false,
    error: null,
    data: null,
  },
  audiobooksDetails: {
    loading: false,
    error: null,
    data: null,
  },
  campaignAndChannel: {
    loading: false,
    error: null,
    data: null,
  },
  campaignDetails: {
    loading: false,
    error: null,
    data: null,
  },
  kpiDataDump: {
    loading: false,
    error: null,
    data: null,
  },
  downloadKpiDataDump: {},
  totalMealImagesUploaded: {
    loading: false,
    error: null,
    data: null,
  },
  totalMealsAdded: {
    loading: false,
    error: null,
    data: null,
  },
  totalAICoachMessages: {
    loading: false,
    error: null,
    data: null,
  },
  uniqueNutritionUsers: {
    loading: false,
    error: null,
    data: null,
  },
};

const mergeData = (data, payload) => {
  const copyData = { ...(data ?? {}) };
  const existingKeys = Object.keys(copyData);
  const newKeys = Object.keys(payload);

  for (const newKey of newKeys) {
    for (const oldKey of existingKeys) {
      if (isPartialMatch(newKey, oldKey)) {
        delete copyData[oldKey];
      }
    }
  }
  const newPayload = {
    ...copyData,
    ...payload,
  };

  const keys = Object.keys(newPayload);
  const sortedKeys = keys.sort((a, b) => new Date(a) - new Date(b));
  const sortedObj = {};

  for (const key of sortedKeys) {
    sortedObj[key] = newPayload[key];
  }
  return sortedObj;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'CLEAR_KPI_STATE':
      return {
        ...initialState,
        currentDateRange: state.currentDateRange,
      };
      
    case 'RESET_KPI_STATE':
      return {
        ...state,
        last12Months: {
          ...initialState.last12Months,
          dateRange: state.last12Months.dateRange,
        },
      };

    case 'RESET_KPI_STATE_90_DATE':
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          dateRange: state.last90Days.dateRange,
        },
      };

    case 'RESET_KPI_STATE_30_DATE':
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          dateRange: state.last30Days.dateRange,
        },
      };

    case 'RESET_INDIVIDUAL_DETAILS_STATE': {
      return {
        ...state,
        individualDetails: {
          loading: false,
          error: null,
          currentDateRange: {
            ...state.individualDetails.currentDateRange,
            [action.payload.field]: {
              ...state.individualDetails.currentDateRange[action.payload.field],
              quarterly: false,
            },
          },
          data: {
            ...state.individualDetails.data,
            [action.payload.field]: [],
          },
        },
      };
    }

    case 'RESET_90_DAYS_INDIVIDUAL_DETAILS_STATE': {
      return {
        ...state,
        individualDetailsLast90Days: {
          loading: false,
          error: null,
          dateRange: {
            ...state.individualDetailsLast90Days.dateRange,
            [action.payload.field]: {
              ...state.individualDetailsLast90Days.dateRange[action.payload.field],
              quarterly: false,
            },
          },
          data: {
            ...state.individualDetailsLast90Days.data,
            [action.payload.field]: [],
          },
        },
      };
    }

    case 'RESET_30_DAYS_INDIVIDUAL_DETAILS_STATE': {
      return {
        ...state,
        individualDetailsLast30Days: {
          loading: false,
          error: null,
          dateRange: {
            ...state.individualDetailsLast30Days.dateRange,
            [action.payload.field]: {
              ...state.individualDetailsLast30Days.dateRange[action.payload.field],
              quarterly: false,
            },
          },
          data: {
            ...state.individualDetailsLast30Days.data,
            [action.payload.field]: [],
          },
        },
      };
    }

    case 'HARD_RESET_KPI_STATE': {
      return initialState;
    }

    case SAVE_CURRENT_DATE_RANGE:
      return {
        ...state,
        currentDateRange: action.payload,
      };

    case SAVE_DATE_RANGE_12_MONTHS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          dateRange: action.payload,
        },
      };

    case SAVE_DATE_RANGE_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          dateRange: action.payload,
        },
      };

    case SAVE_DATE_RANGE_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          dateRange: action.payload,
        },
      };

    case SAVE_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: action.payload,
      };

    case GET_CORPORATE_LIST_LOADING:
      return {
        ...state,
        corporateList: {
          ...state.corporateList,
          loading: true,
          error: null,
        },
      };
    case GET_CORPORATE_LIST:
      return {
        ...state,
        corporateList: {
          loading: false,
          error: null,
          data: action.payload,
        },
      };
    case GET_CORPORATE_LIST_ERROR:
      return {
        ...state,
        corporateList: {
          ...state.corporateList,
          loading: false,
          error: action.error,
        },
      };

    case GET_FREEMIUM_CORPORATE_LIST_LOADING:
      return {
        ...state,
        freemiumCorporateList: {
          ...state.freemiumCorporateList,
          loading: true,
          error: null,
        },
      };
    case GET_FREEMIUM_CORPORATE_LIST:
      return {
        ...state,
        freemiumCorporateList: {
          loading: false,
          error: null,
          data: action.payload,
        },
      };
    case GET_FREEMIUM_CORPORATE_LIST_ERROR:
      return {
        ...state,
        freemiumCorporateList: {
          ...state.freemiumCorporateList,
          loading: false,
          error: action.error,
        },
      };

    case SAVE_CORP_ID_NAME_MAP:
      return {
        ...state,
        cropIdNameMap: action.payload,
      };

    case SAVE_FREEMIUM_CORP_ID_NAME_MAP:
      return {
        ...state,
        freemiumCropIdNameMap: action.payload,
      };

    case GET_PAID_REGISTERED_USERS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          paidRegisteredUsers: {
            ...state.last12Months.paidRegisteredUsers,
            loading: true,
            error: null,
          },
        },
      };

    case GET_PAID_REGISTERED_USERS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          paidRegisteredUsers: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.paidRegisteredUsers.data, action.payload),
          },
        },
      };

    case GET_PAID_REGISTERED_USERS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          paidRegisteredUsers: {
            ...state.last12Months.paidRegisteredUsers,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_PAID_REGISTERED_USERS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          paidRegisteredUsers: action.payload,
        },
      };
    case GET_PAID_REGISTERED_USERS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          paidRegisteredUsers: action.payload,
        },
      };

    case GET_ACTIVE_USERS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          activeUsers: {
            ...state.last12Months.activeUsers,
            loading: true,
            error: null,
          },
        },
      };

    case GET_ACTIVE_USERS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          activeUsers: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.activeUsers.data, action.payload),
          },
        },
      };

    case GET_ACTIVE_USERS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          activeUsers: {
            ...state.last12Months.activeUsers,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_ACTIVE_USERS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          activeUsers: action.payload,
        },
      };
    case GET_ACTIVE_USERS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          activeUsers: action.payload,
        },
      };

    case GET_KPI_DATA_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          kpiData: {
            loading: true,
            error: null,
            data: null,
          },
        },
      };

    case GET_KPI_DATA:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          kpiData: {
            loading: false,
            error: null,
            data: action.payload,
          },
        },
      };

    case GET_KPI_DATA_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          kpiData: {
            loading: false,
            error: action.error,
            data: null,
          },
        },
      };

    case GET_TOTAL_USERS_PLAYED_CONTENT_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersPlayedContent: {
            ...state.last12Months.totalUsersPlayedContent,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_USERS_PLAYED_CONTENT:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersPlayedContent: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalUsersPlayedContent.data, action.payload),
          },
        },
      };

    case GET_TOTAL_USERS_PLAYED_CONTENT_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersPlayedContent: {
            ...state.last12Months.totalUsersPlayedContent,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalUsersPlayedContent: action.payload,
        },
      };
    case GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalUsersPlayedContent: action.payload,
        },
      };

    case GET_TOTAL_MINS_PLAYED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMinsPlayed: {
            ...state.last12Months.totalMinsPlayed,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_MINS_PLAYED:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMinsPlayed: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalMinsPlayed.data, action.payload),
          },
        },
      };

    case GET_TOTAL_MINS_PLAYED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMinsPlayed: {
            ...state.last12Months.totalMinsPlayed,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_MINS_PLAYED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalMinsPlayed: action.payload,
        },
      };

    case GET_TOTAL_MINS_PLAYED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalMinsPlayed: action.payload,
        },
      };

    case GET_USERS_RATED_THE_CONTENT_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          usersRatedTheContent: {
            ...state.last12Months.usersRatedTheContent,
            loading: true,
            error: null,
          },
        },
      };

    case GET_USERS_RATED_THE_CONTENT:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          usersRatedTheContent: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.usersRatedTheContent.data, action.payload),
          },
        },
      };

    case GET_USERS_RATED_THE_CONTENT_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          usersRatedTheContent: {
            ...state.last12Months.usersRatedTheContent,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          usersRatedTheContent: action.payload,
        },
      };

    case GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          usersRatedTheContent: action.payload,
        },
      };

    case GET_USERS_FAVORITE_THE_CONTENT_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          usersFavoriteTheContent: {
            ...state.last12Months.usersFavoriteTheContent,
            loading: true,
            error: null,
          },
        },
      };

    case GET_USERS_FAVORITE_THE_CONTENT:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          usersFavoriteTheContent: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.usersFavoriteTheContent.data, action.payload),
          },
        },
      };

    case GET_USERS_FAVORITE_THE_CONTENT_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          usersFavoriteTheContent: {
            ...state.last12Months.usersFavoriteTheContent,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          usersFavoriteTheContent: action.payload,
        },
      };

    case GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          usersFavoriteTheContent: action.payload,
        },
      };

    case GET_TOTAL_STEPS_CAPTURED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalStepsCaptured: {
            ...state.last12Months.totalStepsCaptured,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_STEPS_CAPTURED:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalStepsCaptured: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalStepsCaptured.data, action.payload),
          },
        },
      };

    case GET_TOTAL_STEPS_CAPTURED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalStepsCaptured: {
            ...state.last12Months.totalStepsCaptured,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalStepsCaptured: action.payload,
        },
      };

    case GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalStepsCaptured: action.payload,
        },
      };

    case GET_TOTAL_USER_SYNCING_STEPS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersSyncingSteps: {
            ...state.last12Months.totalUsersSyncingSteps,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_USER_SYNCING_STEPS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersSyncingSteps: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalUsersSyncingSteps.data, action.payload),
          },
        },
      };

    case GET_TOTAL_USER_SYNCING_STEPS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersSyncingSteps: {
            ...state.last12Months.totalUsersSyncingSteps,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalUsersSyncingSteps: action.payload,
        },
      };

    case GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalUsersSyncingSteps: action.payload,
        },
      };

    case GET_NUMBER_OF_PC_COMPLETED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfPcCompleted: {
            ...state.last12Months.numberOfPcCompleted,
            loading: true,
            error: null,
          },
        },
      };

    case GET_NUMBER_OF_PC_COMPLETED:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfPcCompleted: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.numberOfPcCompleted.data, action.payload),
          },
        },
      };

    case GET_NUMBER_OF_PC_COMPLETED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfPcCompleted: {
            ...state.last12Months.numberOfPcCompleted,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          numberOfPcCompleted: action.payload,
        },
      };

    case GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          numberOfPcCompleted: action.payload,
        },
      };

    case GET_NUMBER_OF_PC_BOOKINGS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfPcBookings: {
            ...state.last12Months.numberOfPcBookings,
            loading: true,
            error: null,
          },
        },
      };

    case GET_NUMBER_OF_PC_BOOKINGS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfPcBookings: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.numberOfPcBookings.data, action.payload),
          },
        },
      };

    case GET_NUMBER_OF_PC_BOOKINGS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfPcBookings: {
            ...state.last12Months.numberOfPcBookings,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          numberOfPcBookings: action.payload,
        },
      };

    case GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          numberOfPcBookings: action.payload,
        },
      };

    case GET_NUMBER_OF_USERS_TAKE_WATER_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfUsersTakingWaterIntake: {
            ...state.last12Months.numberOfUsersTakingWaterIntake,
            loading: true,
            error: null,
          },
        },
      };

    case GET_NUMBER_OF_USERS_TAKE_WATER:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfUsersTakingWaterIntake: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.numberOfUsersTakingWaterIntake.data, action.payload),
          },
        },
      };

    case GET_NUMBER_OF_USERS_TAKE_WATER_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          numberOfUsersTakingWaterIntake: {
            ...state.last12Months.numberOfUsersTakingWaterIntake,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          numberOfUsersTakingWaterIntake: action.payload,
        },
      };

    case GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          numberOfUsersTakingWaterIntake: action.payload,
        },
      };

    case GET_TOTAL_WATER_INTAKE_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalWaterIntake: {
            ...state.last12Months.totalWaterIntake,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_WATER_INTAKE:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalWaterIntake: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalWaterIntake.data, action.payload),
          },
        },
      };

    case GET_TOTAL_WATER_INTAKE_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalWaterIntake: {
            ...state.last12Months.totalWaterIntake,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_EARNED_REWARD_POINTS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalEarnedRewardPoints: {
            ...state.last12Months.totalEarnedRewardPoints,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_EARNED_REWARD_POINTS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalEarnedRewardPoints: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalEarnedRewardPoints.data, action.payload),
          },
        },
      };

    case GET_TOTAL_EARNED_REWARD_POINTS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalEarnedRewardPoints: {
            ...state.last12Months.totalEarnedRewardPoints,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalEarnedRewardPoints: action.payload,
        },
      };

    case GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalEarnedRewardPoints: action.payload,
        },
      };

    case GET_TOTAL_REDEEMED_REWARD_POINTS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalRedeemedRewardPoints: {
            ...state.last12Months.totalRedeemedRewardPoints,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_REDEEMED_REWARD_POINTS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalRedeemedRewardPoints: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalRedeemedRewardPoints.data, action.payload),
          },
        },
      };

    case GET_TOTAL_REDEEMED_REWARD_POINTS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalRedeemedRewardPoints: {
            ...state.last12Months.totalRedeemedRewardPoints,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalRedeemedRewardPoints: action.payload,
        },
      };

    case GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalRedeemedRewardPoints: action.payload,
        },
      };

    case GET_TOTAL_USERS_EARNED_REWARDS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersEarnedReward: {
            ...state.last12Months.totalUsersEarnedReward,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_USERS_EARNED_REWARDS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersEarnedReward: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalUsersEarnedReward.data, action.payload),
          },
        },
      };

    case GET_TOTAL_USERS_EARNED_REWARDS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersEarnedReward: {
            ...state.last12Months.totalUsersEarnedReward,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalUsersEarnedReward: action.payload,
        },
      };

    case GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalUsersEarnedReward: action.payload,
        },
      };

    case GET_TOTAL_USERS_REDEEMED_REWARDS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersRedeemedReward: {
            ...state.last12Months.totalUsersRedeemedReward,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_USERS_REDEEMED_REWARDS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersRedeemedReward: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalUsersRedeemedReward.data, action.payload),
          },
        },
      };

    case GET_TOTAL_USERS_REDEEMED_REWARDS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersRedeemedReward: {
            ...state.last12Months.totalUsersRedeemedReward,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalUsersRedeemedReward: action.payload,
        },
      };

    case GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalUsersRedeemedReward: action.payload,
        },
      };

    case GET_TOTAL_PUSH_SENT_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalPushSent: {
            ...state.last12Months.totalPushSent,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_PUSH_SENT:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalPushSent: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalPushSent.data, action.payload),
          },
        },
      };

    case GET_TOTAL_PUSH_SENT_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalPushSent: {
            ...state.last12Months.totalPushSent,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_PUSH_SENT_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalPushSent: action.payload,
        },
      };

    case GET_TOTAL_PUSH_SENT_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalPushSent: action.payload,
        },
      };

    case GET_TOTAL_CHALLENGES_LAUNCHED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalChallengesLaunched: {
            ...state.last12Months.totalChallengesLaunched,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_CHALLENGES_LAUNCHED:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalChallengesLaunched: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalChallengesLaunched.data, action.payload),
          },
        },
      };

    case GET_TOTAL_CHALLENGES_LAUNCHED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalChallengesLaunched: {
            ...state.last12Months.totalChallengesLaunched,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalChallengesLaunched: action.payload,
        },
      };

    case GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalChallengesLaunched: action.payload,
        },
      };

    case GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersJoinedInChallenge: {
            ...state.last12Months.totalUsersJoinedInChallenge,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_USERS_JOINED_IN_CHALLENGE:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersJoinedInChallenge: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalUsersJoinedInChallenge.data, action.payload),
          },
        },
      };

    case GET_TOTAL_USERS_JOINED_IN_CHALLENGE_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersJoinedInChallenge: {
            ...state.last12Months.totalUsersJoinedInChallenge,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalUsersJoinedInChallenge: action.payload,
        },
      };

    case GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalUsersJoinedInChallenge: action.payload,
        },
      };

    case GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersParticipatedInChallenge: {
            ...state.last12Months.totalUsersParticipatedInChallenge,
            loading: true,
            error: null,
          },
        },
      };

    case GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersParticipatedInChallenge: {
            loading: false,
            error: null,
            data: mergeData(
              state.last12Months.totalUsersParticipatedInChallenge.data,
              action.payload
            ),
          },
        },
      };

    case GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalUsersParticipatedInChallenge: {
            ...state.last12Months.totalUsersParticipatedInChallenge,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalUsersParticipatedInChallenge: action.payload,
        },
      };

    case GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalUsersParticipatedInChallenge: action.payload,
        },
      };

    case GET_PROGRAM_JOINED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          programJoined: {
            ...state.last12Months.programJoined,
            loading: true,
            error: null,
          },
        },
      };

    case GET_PROGRAM_JOINED:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          programJoined: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.programJoined.data, action.payload),
          },
        },
      };

    case GET_PROGRAM_JOINED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          programJoined: {
            ...state.last12Months.programJoined,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_PROGRAM_JOINED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          programJoined: action.payload,
        },
      };

    case GET_PROGRAM_JOINED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          programJoined: action.payload,
        },
      };

    case GET_PROGRAM_COMPLETED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          programCompleted: {
            ...state.last12Months.programCompleted,
            loading: true,
            error: null,
          },
        },
      };

    case GET_PROGRAM_COMPLETED:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          programCompleted: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.programCompleted.data, action.payload),
          },
        },
      };

    case GET_PROGRAM_COMPLETED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          programCompleted: {
            ...state.last12Months.programCompleted,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_PROGRAM_COMPLETED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          programCompleted: action.payload,
        },
      };

    case GET_PROGRAM_COMPLETED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          programCompleted: action.payload,
        },
      };

    case GET_BOOK_READ_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          bookRead: {
            ...state.last12Months.bookRead,
            loading: true,
            error: null,
          },
        },
      };

    case GET_BOOK_READ:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          bookRead: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.bookRead.data, action.payload),
          },
        },
      };

    case GET_BOOK_READ_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          bookRead: {
            ...state.last12Months.bookRead,
            loading: false,
            error: action.error,
          },
        },
      };

    case GET_BOOK_READ_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          bookRead: action.payload,
        },
      };

    case GET_BOOK_READ_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          bookRead: action.payload,
        },
      };

    case GET_INDIVIDUAL_DETAILS_LOADING:
      return {
        ...state,
        individualDetails: {
          ...state.individualDetails,
          loading: true,
          error: null,
        },
      };

    case GET_INDIVIDUAL_DETAILS:
      return {
        ...state,
        individualDetails: {
          ...state.individualDetails,
          loading: false,
          error: null,
          data: {
            ...state.individualDetails.data,
            ...action.payload,
          },
        },
      };

    case GET_INDIVIDUAL_DETAILS_ERROR:
      return {
        ...state,
        individualDetails: {
          ...state.individualDetails,
          loading: false,
          error: action.error,
        },
      };

    case GET_INDIVIDUAL_DETAILS_LAST_90_DAYS:
      return {
        ...state,
        individualDetailsLast90Days: {
          ...state.individualDetailsLast90Days,
          loading: action.payload.loading,
          error: action.payload.error,
          data: {
            ...state.individualDetailsLast90Days.data,
            ...(action.payload.data || {}),
          },
        },
      };

    case GET_INDIVIDUAL_DETAILS_LAST_30_DAYS:
      return {
        ...state,
        individualDetailsLast30Days: {
          ...state.individualDetailsLast30Days,
          loading: action.payload.loading,
          error: action.payload.error,
          data: {
            ...state.individualDetailsLast30Days.data,
            ...(action.payload.data || {}),
          },
        },
      };

    case SAVE_CURRENT_DATE_RANGE_FOR_INDIVIDUAL:
      return {
        ...state,
        individualDetails: {
          ...state.individualDetails,
          currentDateRange: {
            ...state.individualDetails.currentDateRange,
            ...action.payload,
          },
        },
      };

    case SAVE_DATE_RANGE_FOR_90_DAYS_INDIVIDUAL:
      return {
        ...state,
        individualDetailsLast90Days: {
          ...state.individualDetailsLast90Days,
          dateRange: {
            ...state.individualDetailsLast90Days.dateRange,
            ...action.payload,
          },
        },
      };

    case SAVE_DATE_RANGE_FOR_30_DAYS_INDIVIDUAL:
      return {
        ...state,
        individualDetailsLast30Days: {
          ...state.individualDetailsLast30Days,
          dateRange: {
            ...state.individualDetailsLast30Days.dateRange,
            ...action.payload,
          },
        },
      };

    case GET_AUDIO_BOOKS_ALLOCATION:
      return {
        ...state,
        audiobooksAllocation: {
          ...state.audiobooksAllocation,
          ...action.payload,
        },
      };

    case GET_AUDIOBOOKS_DETAILS:
      return {
        ...state,
        audiobooksDetails: {
          ...state.audiobooksDetails,
          ...action.payload,
        },
      };

    case GET_CAMPAIGN_AND_CHANNEL:
      return {
        ...state,
        campaignAndChannel: {
          ...state.campaignAndChannel,
          ...action.payload,
        },
      };

    case GET_CAMPAIGN_DETAILS:
      return {
        ...state,
        campaignDetails: {
          ...state.campaignDetails,
          ...action.payload,
        },
      };

    case DOWNLOAD_PDF:
      return {
        ...state,
        pdfLoading: false,
      };
    case DOWNLOAD_PDF_LOADING:
      return {
        ...state,
        pdfLoading: true,
      };
    case DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        pdfLoading: false,
      };

    case DOWNLOAD_OVERALL_REPORT_LOADING:
      return {
        ...state,
        overallReport: {
          loading: true,
          data: null,
          error: null,
        },
      };

    case DOWNLOAD_OVERALL_REPORT:
      return {
        ...state,
        overallReport: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case DOWNLOAD_OVERALL_REPORT_ERROR:
      return {
        ...state,
        overallReport: {
          loading: false,
          data: null,
          error: action.error,
        },
      };

    case SAVE_KPI_DATA_DUMP:
      return {
        ...state,
        kpiDataDump: {
          ...action.payload,
        },
      };

    case DOWNLOAD_KPI_DATA_DUMP:
      return {
        ...state,
        downloadKpiDataDump: {
          ...action.payload,
        },
      };
    
    case FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalMealImagesUploaded: action.payload,
        },
      };

    case FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalMealImagesUploaded: action.payload,
        },
      };

    case FETCH_TOTAL_MEAL_IMAGES_UPLOADED_SUCCESS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMealImagesUploaded: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalMealImagesUploaded?.data || {}, action.payload),
          },
        },
      };

    case FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMealImagesUploaded: {
            ...state.last12Months.totalMealImagesUploaded,
            loading: true,
            error: null,
          },
        },
      };

    case FETCH_TOTAL_MEAL_IMAGES_UPLOADED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMealImagesUploaded: {
            ...state.last12Months.totalMealImagesUploaded,
            loading: false,
            error: action.error,
          },
        },
      };

    case FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalMealsAdded: action.payload,
        },
      };

    case FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalMealsAdded: action.payload,
        },
      };  

    case FETCH_TOTAL_MEALS_ADDED_SUCCESS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMealsAdded: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalMealsAdded?.data || {}, action.payload),
          },
        },
      };
    case FETCH_TOTAL_MEALS_ADDED_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMealsAdded: {
            ...state.last12Months.totalMealsAdded,
            loading: true,
            error: null,
          },
        },
      };

    case FETCH_TOTAL_MEALS_ADDED_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalMealsAdded: {
            ...state.last12Months.totalMealsAdded,
            loading: false,
            error: action.error,
          },
        },
      };  

    case FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          totalAICoachMessages: action.payload,
        },
      };
    case FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          totalAICoachMessages: action.payload,
        },
      };  
    case FETCH_TOTAL_AI_COACH_MESSAGES_SUCCESS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalAICoachMessages: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.totalAICoachMessages || {}, action.payload),
          },
        },
      };  
    case FETCH_TOTAL_AI_COACH_MESSAGES_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalAICoachMessages: {
            ...state.last12Months.totalAICoachMessages,
            loading: true,
            error: null,
          },
        },
      };  
    case FETCH_TOTAL_AI_COACH_MESSAGES_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          totalAICoachMessages: {
            ...state.last12Months.totalAICoachMessages,
            loading: false,
            error: action.error,
          },
        },
      };  

    case FETCH_UNIQUE_NUTRITION_USERS_SUCCESS:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          uniqueNutritionUsers: {
            loading: false,
            error: null,
            data: mergeData(state.last12Months.uniqueNutritionUsers, action.payload),
          },
        },
      };

    case FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS:
      return {
        ...state,
        last90Days: {
          ...state.last90Days,
          uniqueNutritionUsers: action.payload,
        },
      };

    case FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS:
      return {
        ...state,
        last30Days: {
          ...state.last30Days,
          uniqueNutritionUsers: action.payload,
        },
      };
    case FETCH_UNIQUE_NUTRITION_USERS_LOADING:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          uniqueNutritionUsers: {
            ...state.last12Months.uniqueNutritionUsers,
            loading: true,
            error: null,
          },
        },
      };

    case FETCH_UNIQUE_NUTRITION_USERS_ERROR:
      return {
        ...state,
        last12Months: {
          ...state.last12Months,
          uniqueNutritionUsers: {
            ...state.last12Months.uniqueNutritionUsers,
            loading: false,
            error: action.error,
          },
        },
      };  

    default:
      return state;
  }
}
